import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import auth from './reducers/auth';
import bugsnag from './reducers/bugsnag';
import user from './reducers/user';
import notifications from './reducers/notifications';
import google from './reducers/google';

export default combineReducers( {
  auth: auth,
  bugsnag: bugsnag,
  user: user,
  notifications: notifications,
  route: routerReducer,
  google: google
} );



// WEBPACK FOOTER //
// ./src/redux/reducers.js